import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export function useCatalog() {
  const [catalog, setCatalog] = useState(cache);
  useEffect(() => {
    // always refetch so newly-saved catalog changes show up (still paints cached instantly)
    api.get("/catalog").then(({ data }) => { cache = data; setCatalog(data); }).catch(() => {});
  }, []);
  return catalog;
}
